export const numberWithCommas = x => {
  if (x !== undefined) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}



// WEBPACK FOOTER //
// ./src/helpers/priceFormater.ts